export const roleAccesscolumns = [
    { Header: 'Id', accessor: 'id' },
    { Header: 'User', accessor: 'userName' },
    { Header: 'Role', accessor: 'roleName' },
    { Header: 'Action', Cell: ({ row }) => row.original.action, accessor: 'action' },
];